// extracted by mini-css-extract-plugin
var _1 = "SearchFacet-module__facetPill--nYuol";
export { _1 as "facetPill" }
